























import { Component, Vue, Prop } from 'vue-property-decorator'
import { Message } from 'element-ui'

@Component({ components: {} })
export default class Header extends Vue {
  username: any = '/api/v1/agents/login'
  created() {
    this.username = sessionStorage.getItem('username')
  }
  isDialog: boolean = false
  dialogData: any
  // 绑定谷歌验证码
  dialogLoginData: any = {
    optionTitle: '修改登录密码',
    modifyForm: {
      url: `/api/v1/agents/${sessionStorage.getItem('username')}/password`,
      width: '30%',
      form: {
        account: sessionStorage.getItem('username'),
        password: '',
        new_password: '',
        confirm_password: ''
      },
      showData: [],
      formLabelWidth: '100px',
      data: [
        {
          type: 'input',
          model: 'password',
          name: '原登录密码'
        },
        {
          type: 'input',
          model: 'new_password',
          name: '新登录密码'
        },
        {
          type: 'input',
          model: 'confirm_password',
          name: '确认新密码'
        }
      ],
      select: {
        role: []
      }
    },
    rules: {
      password: [
        {
          required: true,
          message: '请输入原密码',
          trigger: 'blur'
        }
      ],
      new_password: [
        {
          required: true,
          message: '请输入新密码',
          trigger: 'blur'
        }
      ],
      confirm_password: [
        {
          required: true,
          message: '请再次输入新密码',
          trigger: 'blur'
        }
      ]
    }
  }
  // 绑定谷歌验证码
  dialogPayData: any = {
    optionTitle: '修改支付密码',
    modifyForm: {
      url: `/api/v1/agents/${sessionStorage.getItem('username')}/pay-password`,
      width: '30%',
      form: {
        account: sessionStorage.getItem('username'),
        pay_password: '',
        new_pay_password: '',
        confirm_pay_password: ''
      },
      showData: [],
      formLabelWidth: '100px',
      data: [
        {
          type: 'input',
          model: 'pay_password',
          name: '原支付密码'
        },
        {
          type: 'input',
          model: 'new_pay_password',
          name: '新支付密码'
        },
        {
          type: 'input',
          model: 'confirm_pay_password',
          name: '确认新密码'
        }
      ],
      select: {
        role: []
      }
    },
    rules: {
      pay_password: [
        {
          required: true,
          message: '请输入原密码',
          trigger: 'blur'
        }
      ],
      new_pay_password: [
        {
          required: true,
          message: '请输入新密码',
          trigger: 'blur'
        }
      ],
      confirm_pay_password: [
        {
          required: true,
          message: '请再次输入新密码',
          trigger: 'blur'
        }
      ]
    }
  }
  // 退出登录
  private handleCommand(command: string) {
    if (command === 'logout') {
      this.logout()
    } else if (command === 'loginPassword') {
      this.isDialog = true
      this.dialogData = this.dialogLoginData
    } else if (command === 'payPassword') {
      this.isDialog = true
      this.dialogData = this.dialogPayData
    }
  }
  private refesh(bool: boolean) {
    if (bool) {
      this.logout()
    }
    this.isDialog = false
  }
  private logout() {
    sessionStorage.removeItem('Apk-Jwt-Token')
    this.$router.push('/login')
    Message({
      message: '退出登录成功',
      type: 'success',
      duration: 5 * 1000
    })
  }
}
